import { render, staticRenderFns } from "./product-system.vue?vue&type=template&id=7f225ee9&scoped=true"
import script from "./product-system.vue?vue&type=script&lang=js"
export * from "./product-system.vue?vue&type=script&lang=js"
import style0 from "./product-system.vue?vue&type=style&index=0&id=7f225ee9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f225ee9",
  null
  
)

export default component.exports